import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, ProductStatusModel } from 'Models'
import { MerchantStatusModel, MerchantStatusCreateModel } from 'Pages/admin/merchantStatus'
import { Callback } from 'Src/types/utilTypes'

export type MerchantStatusState = {
	reload: boolean
	list: ResponseCatalog<MerchantStatusModel>
	edit: MerchantStatusModel | null
	requestParams: RequestParams
	statuses: ResponseCatalog<ProductStatusModel>
	statusParams: RequestParams
}

export const merchantStatusInitialState: MerchantStatusState = {
	reload: false,
	list: new ResponseCatalog<MerchantStatusModel>(),
	edit: null,
	requestParams: new RequestParams(),
	statuses: new ResponseCatalog<ProductStatusModel>(),
	statusParams: new RequestParams(),
}

export namespace MerchantStatusNS {
	export type GetMerchantStatusList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type GetOne = PayloadAction<string>
	export type SetOne = PayloadAction<MerchantStatusModel>
	export type UpdateOne = PayloadAction<{
		id: string
		data: MerchantStatusCreateModel
		callback?: Function
	}>
	export type CreateOne = PayloadAction<MerchantStatusCreateModel>
	export type DeleteOne = PayloadAction<string>
	export type SetMerchantStatusList = PayloadAction<ResponseCatalog<MerchantStatusModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type GetProductStatuses = PayloadAction<{
		params: RequestParams
	}>
	export type SetProductStatuses = PayloadAction<ResponseCatalog<ProductStatusModel>>
	export type SetStatusParams = PayloadAction<RequestParams>
}

export const merchantStatusSlice = createSlice({
	name: 'merchant_status',
	initialState: merchantStatusInitialState,
	reducers: {
		getAll: (state, action: MerchantStatusNS.GetMerchantStatusList) => {},
		setAll: (state, action: MerchantStatusNS.SetMerchantStatusList) => {
			state.reload = state?.reload ?? false
			state.list = action.payload
		},
		setRequestParams: (state, action: MerchantStatusNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.list = new ResponseCatalog<MerchantStatusModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: MerchantStatusNS.GetOne) => {},
		setOne: (state, action: MerchantStatusNS.SetOne) => {
			state.edit = action.payload
		},
		updateOne: (state, action: MerchantStatusNS.UpdateOne) => {},
		createOne: (state, action: MerchantStatusNS.CreateOne) => {},
		deleteOne: (state, action: MerchantStatusNS.DeleteOne) => {},
		getProductStatuses: (state, action: MerchantStatusNS.GetProductStatuses) => {},
		setProductStatuses: (state, action: MerchantStatusNS.SetProductStatuses) => {
			state.statuses = action.payload
		},
		setStatusParams: (state, action: MerchantStatusNS.SetStatusParams) => {
			state.statusParams = action.payload
		},
		clearProductStatuses: (state) => {
			state.statuses = new ResponseCatalog<ProductStatusModel>()
			state.statusParams = new RequestParams()
		},
	},
})
